<style lang="scss" scoped src="./style.scss" />
<script lang="ts" src="./script.ts" />

<template>
    <div class="page">
        <main>
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8 offset-md-2">
                        <div class="card">
                            <div class="card-header">
                                <Logo :logoUrl="data.clientLogoUrl" />
                            </div>
                            <div class="card-body">
                                <div class="progress-wrap margin-bottom-28">
                                    <r-stepper v-if="hasSteps()">
                                        <r-stepper-item number="1" complete="">{{ getTranslation("OtpStart") }}</r-stepper-item>
                                        <r-stepper-item number="2" active="">{{ getTranslation(selectedOtpType == OtpType.Email ? "OtpEmailCode" : "OtpSmsCode") }}</r-stepper-item>
                                        <r-stepper-item number="3">{{ getTranslation("OtpBirthDateLabel") }}</r-stepper-item>
                                    </r-stepper>
                                </div>
                                <h5 class="title">{{ getTranslation("OtpIntroTitle") }}</h5>
                                <p class="subtitle margin-bottom-40">
                                    {{ getTranslation("OtpIntroDescription") }}
                                </p>
                                <p class="subtitle margin-bottom-40">
                                    {{ getTranslation("OtpIntroSmsAndEmailDescription") }}
                                </p>
                                <form>
                                    <div class="row align-items-center clickable" tabindex="0" v-on:click="changeOtpType(OtpType.Email)" v-on:keyup.enter="changeOtpType(OtpType.Email)">
                                        <div class="col-auto pe-1">
                                            <label class="custom-radio">
                                                <input
                                                    type="radio"
                                                    id="emailRadio"
                                                    name="otpTypeRadio"
                                                    :value="OtpType.Email"
                                                    :disabled="emailDisabled"
                                                    :checked="selectedOtpType == OtpType.Email"
                                                    v-on:keyup.space="changeOtpType(OtpType.Email)"
                                                    v-on:keyup.enter="changeOtpType(OtpType.Email)"
                                                    v-on:click="changeOtpType(OtpType.Email)" />
                                            </label>
                                        </div>
                                        <div class="col">
                                            <p class="r-font-weight-semibold">{{ getTranslation("OtpSelectMethodViaEmail") }} {{ data.email }}</p>
                                        </div>
                                    </div>
                                    <div class="row align-items-center clickable" tabindex="1" v-on:click="changeOtpType(OtpType.Sms)" v-on:keyup.enter="changeOtpType(OtpType.Sms)">
                                        <div class="col-auto pe-1">
                                            <label class="custom-radio">
                                                <input
                                                    type="radio"
                                                    id="smsRadio"
                                                    name="otpTypeRadio"
                                                    :value="OtpType.Sms"
                                                    :disabled="smsDisabled"
                                                    :checked="selectedOtpType == OtpType.Sms"
                                                    v-on:keyup.space="changeOtpType(OtpType.Sms)"
                                                    v-on:keyup.enter="changeOtpType(OtpType.Sms)"
                                                    v-on:click="changeOtpType(OtpType.Sms)" />
                                            </label>
                                        </div>
                                        <div class="col">
                                            <p class="r-font-weight-semibold">{{ getTranslation("OtpSelectMethodViaSms") }} {{ data.phoneNumber }}</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer">
                                <div class="footer">
                                    <div class="row">
                                        <div class="col-sm-auto mb-3">
                                            <r-button id="redirectBtn" class="footer-button" expanded="" disabled v-on:click="redirect" v-on:keyup.enter="redirect">{{ getTranslation("OtpRequestCode") }}</r-button>
                                        </div>
                                        <div class="col-sm-auto order-sm-first">
                                            <r-button class="footer-button order-md-1" variant="secondary" expanded="" v-on:click="goBack">{{ getTranslation("OtpClose") }}</r-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
